import { ApplicationDTO, ApplicationRoleDTO, UserDTO } from "./DTO"
import { Application, ApplicationRole, User } from "../../../@type/management/user"

export const mapperApllicationDTOToModel = (a: ApplicationDTO): Application => ({
    id: a.i,
    Code: a.c,
    Name: a.n,
    Roles: a.r.map(mapperApllicationRoleDTOToModel)
});

const mapperApllicationRoleDTOToModel = (r: ApplicationRoleDTO): ApplicationRole => ({
    id: r.i,
    ApplicationID: r.a,
    Code: r.c,
    Name: r.n
});

export const mapperUserDTOToModel = (u: UserDTO): User => ({
    Email: u.e,
    FullName: u.f,
    Active: u.a,
    UserName: u.u,
    id: u.i,
    Roles: u.r.map(mapperApllicationRoleDTOToModel)
});
